// Shared mutation key prefix so SaveFeedback can show one toast for any settings save.
export const settingsMutationKey = ['settings', 'save'] as const;
